import { render, staticRenderFns } from "./AdminRequestsDetailsView.vue?vue&type=template&id=3bdd50ad&scoped=true"
import script from "./AdminRequestsDetailsView.vue?vue&type=script&lang=js"
export * from "./AdminRequestsDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdd50ad",
  null
  
)

export default component.exports